<template>
  
  
  <div id="app">
    <div class="fulfilling-bouncing-circle-spinner " >
  <div class="circle"></div>
  <div class="orbit"></div>
</div>
    <Navbar ></Navbar>
    <!--<div id="nav"></div>-->
  
    <router-view/>
  </div>
  
</template>
<script>
import Navbar from './views/Navbar'
import { setTimeout } from 'timers';

export default{
  components:{
    Navbar,
   
  }
}
const loader = document.getElementsByClassName('fulfilling-bouncing-circle-spinner')
//const loader = document.querySelector('.fulfilling-bouncing-circle-spinner')
const home = document.querySelector('.home')
function init(){
  setTimeout(()=>{
    
    $('.fulfilling-bouncing-circle-spinner').delay(3000).fadeOut('slow'); 
    $('#home').css("display","block")
    $('.container_nav').css("display","block")
    
    /*
    loader.style.opacity ='0';
    loader.style.display='none';

    home.style.display="block"
    console.log("working")
    

*/
  },5500)
}
init();
</script>
<style>
*{
  background-color:#2c3968;
}
html {
  scroll-behavior: smooth;
}
.fulfilling-bouncing-circle-spinner, .fulfilling-bouncing-circle-spinner * {
      box-sizing: border-box;
     
    }

    .fulfilling-bouncing-circle-spinner {
      height: 60px;
      width: 60px;
      position: absolute;
      animation: fulfilling-bouncing-circle-spinner-animation infinite 4000ms ease;
      transition: 200ms ease-in-out;
     margin:auto;
     top:50%;
     left:47%;
     
    }

    .fulfilling-bouncing-circle-spinner .orbit {
      height: 60px;
      width: 60px;
      position: absolute;
      top: 0;
      left: 0;
      border-radius: 50%;
      border: calc(60px * 0.03) solid #FF033E;
      animation: fulfilling-bouncing-circle-spinner-orbit-animation infinite 4000ms ease;
    }

    .fulfilling-bouncing-circle-spinner .circle {
      height: 60px;
      width: 60px;
      color: #FF033E;
      display: block;
      border-radius: 50%;
      position: relative;
      border: calc(60px * 0.1) solid #FF033E;
      animation: fulfilling-bouncing-circle-spinner-circle-animation infinite 4000ms ease;
      transform: rotate(0deg) scale(1);
    }

    @keyframes fulfilling-bouncing-circle-spinner-animation {
      0% {
        transform: rotate(0deg);
      }

      100% {
        transform: rotate(360deg);
      }
    }

    @keyframes fulfilling-bouncing-circle-spinner-orbit-animation {
      0% {
        transform: scale(1);
      }
      50% {
        transform: scale(1);
      }
      62.5% {
        transform: scale(0.8);
      }
      75% {
        transform: scale(1);
      }
      87.5% {
        transform: scale(0.8);
      }
      100% {
        transform: scale(1);
      }
    }

    @keyframes fulfilling-bouncing-circle-spinner-circle-animation {
      0% {
        transform: scale(1);
        border-color: transparent;
        border-top-color: inherit;
      }
      16.7% {
        border-color: transparent;
        border-top-color: initial;
        border-right-color: initial;
      }
      33.4% {
        border-color: transparent;
        border-top-color: inherit;
        border-right-color: inherit;
        border-bottom-color: inherit;
      }
      50% {
        border-color: inherit;
        transform: scale(1);
      }
      62.5% {
        border-color: inherit;
        transform: scale(1.4);
      }
      75% {
        border-color: inherit;
        transform: scale(1);
        opacity: 1;
      }
      87.5% {
        border-color: inherit;
        transform: scale(1.4);
      }
      100% {
        border-color: transparent;
        border-top-color: inherit;
        transform: scale(1);
      }
    }
@media screen and (max-width:768px){
   .fulfilling-bouncing-circle-spinner {
      height: 60px;
      width: 60px;
      position: absolute;
      animation: fulfilling-bouncing-circle-spinner-animation infinite 4000ms ease;
     margin:auto;
     top:45%;
     left:40%;
     
   }
}
</style>
